module.exports = __webpack_public_path__ + "img/off.9e6fef97.svg";